module.exports = __webpack_public_path__ + "img/OGG_Background_CoralBlue.0546068e.png";